import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const DiagramCard = ({ diagram, onUnlink, showUnlinkButton = false }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: diagram.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    padding: '10px',
    margin: '10px 0',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    cursor: 'grab',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`diagram-card p-3 mb-3 bg-white border rounded shadow-sm 
        ${isDragging ? 'ring-2 ring-gray-500' : ''}`}
    >
      <div className="flex justify-between items-center">
        <div 
          className="font-medium cursor-move flex-grow"
          {...attributes}
          {...listeners}
        >
          {diagram.name}
        </div>
        {showUnlinkButton && (
          <button 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onUnlink(diagram.id);
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onPointerDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            className="ml-2 text-gray-400 hover:text-gray-500 focus:outline-none z-10 relative"
            title="Remove from group"
            style={{ pointerEvents: 'auto' }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
              <polyline points="15 3 21 3 21 9" />
              <line x1="10" y1="14" x2="21" y2="3" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default DiagramCard;
